import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { CanalMidiaSocial, canaisMidiasSociais as canaisDefault } from '../../canal-midia-social';

@Component({
    selector: 'sgt-canal-midia-social-multiselect',
    templateUrl: './canal-midia-social-multiselect.component.html',
    styleUrls: ['./canal-midia-social-multiselect.component.less']
})
export class CanalMidiaSocialMultiselectComponent implements OnInit {
    /** Canais de mídias sociais disponíveis para seleção */
    @Input() canaisOptions: CanalMidiaSocial[] = canaisDefault;

    /** Canais selecionados */
    @Input() canaisMidiasSociais: number[];
    /** Ao alterar a seleção dos canais */
    @Output() canaisMidiasSociaisChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de canal nulo ou seja, para filtrar registros que não possuem o canal */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o canal nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção do canal nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Canal';
    @Input() checked = 'Canal'
    @Input() checkedPlural = 'Canais';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum canal encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-canal-midia-social ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os canais para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Adicionando a opção de "Sem Canal"
        if (this.showNullOption) {
            selects.push({
                id: 0,
                name: 'SEM CANAL'
            });
        }

        this.canaisOptions?.forEach(canal => {
            selects.push({
                id: canal.id,
                name: canal.nome,
                classes: 'multiselect-item-canal-midia-social'
            });
        });

        this.options = selects;
    }

    /** Ao alterar a seleção da opção canal nulo */
    private onChangeNullOption() {
        this.nullOption = this.canaisMidiasSociais.includes(0);
        this.nullOptionChange.emit(this.nullOption);
    }


    /** Ao alterar a seleção dos canais */
    onChange() {
        this.onChangeNullOption();
        this.canaisMidiasSociaisChange.emit(this.canaisMidiasSociais);
    }
}
